export const layoutTexts = {
  appName: 'PM-Tool',
  nav: {
    label: 'Navigation',
    home: 'Übersicht',
    myTasks: 'Meine Tasks',
    projects: 'Projekte',
    myResources: 'Meine Auslastung',
    resources: 'Ressourcen',
    skills: 'Wer kann was?',
    admin: 'Administration',
  },
  toggleSidebar: 'Seitenleiste ein-/ausblenden',
  notFound: {
    title: 'Seite nicht gefunden',
    description: 'Die Seite existiert nicht oder Sie haben keinen Zugriff.',
    backHome: 'Zur Übersicht',
  },
} as const;
